function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { debounce, Debouncer } from "../time";

var SendImageSize = /*#__PURE__*/function () {
  function SendImageSize() {
    _classCallCheck(this, SendImageSize);

    _defineProperty(this, "regular", void 0);

    _defineProperty(this, "transitioned", void 0);
  }

  _createClass(SendImageSize, [{
    key: "setImageSend",
    value: function setImageSend(inputBatchSender, doSendImageSize) {
      var sendImageSizeDebouncer = new Debouncer(null, doSendImageSize, 0);

      this.regular = function () {
        sendImageSizeDebouncer.normalCall();
      }; // Make sure sendImageSize actually gets called before the inputBatchSender
      // sends data to the server.


      inputBatchSender.lastChanceCallback.push(function () {
        if (sendImageSizeDebouncer.isPending()) sendImageSizeDebouncer.immediateCall();
      }); // A version of sendImageSize which debounces for longer.

      this.transitioned = debounce(200, this.regular);
      return sendImageSizeDebouncer;
    }
  }]);

  return SendImageSize;
}();

var sendImageSizeFns = new SendImageSize();
export { sendImageSizeFns };